import { downloadBlob } from './download-blob.util';

/** Download via URL já assinada pelo backend (ex.: S3); não usar credenciais Cognito no cliente. */
export async function downloadFromSignedUrl(
  url: string,
  filename: string,
): Promise<void> {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error('Falha ao baixar o PDF');
  }
  const blob = await response.blob();
  downloadBlob(blob, filename);
}
